/* KYSM — theme behaviour. No dependencies. */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- focus trap helper ---------------- */
  function trap(container, onClose) {
    var prev = document.activeElement;
    function keys(e) {
      if (e.key === 'Escape') { e.preventDefault(); onClose(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', container)
              .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', keys);
    return function release() {
      document.removeEventListener('keydown', keys);
      if (prev && prev.focus) prev.focus();
    };
  }

  /* ---------------- cart drawer ---------------- */
  var cartRelease = null;
  function cartEl() { return $('#cart-drawer'); }

  function openCart() {
    var d = cartEl();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    cartRelease = trap(d, closeCart);
    var x = d.querySelector('button[data-cart-close]');
    if (x) x.focus();
  }
  function closeCart() {
    var d = cartEl();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (cartRelease) { cartRelease(); cartRelease = null; }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var live = $('[data-cart-live]'); if (live) live.textContent = cart.item_count + ' items in cart';
        return cart;
      })
      .catch(function () {});
  }

  function renderDrawer() {
    var d = cartEl();
    if (!d) return Promise.resolve();
    return fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-drawer');
        if (!fresh) return;
        var fb = fresh.querySelector('[data-cart-body]'), lb = d.querySelector('[data-cart-body]');
        if (fb && lb) lb.innerHTML = fb.innerHTML;
        var ft = fresh.querySelector('[data-cart-total]'), lt = d.querySelector('[data-cart-total]');
        if (ft && lt) lt.textContent = ft.textContent;
        var fc = fresh.querySelector('button[name="checkout"]'), lc = d.querySelector('button[name="checkout"]');
        if (fc && lc) lc.disabled = fc.disabled;
      })
      .catch(function () {});
  }

  /* ---------------- modal helper ---------------- */
  function closeModal(m) {
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (m._rel) { m._rel(); m._rel = null; }
  }

  /* ---------------- one delegated click handler ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-cart-open]'))  { e.preventDefault(); openCart();  return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var mb = t.closest('[data-mnav]');
    if (mb) {
      var nav = $('#mnav');
      if (nav) {
        var on = nav.classList.toggle('is-open');
        mb.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      return;
    }

    var qb = t.closest('[data-qty]');
    if (qb) {
      e.preventDefault();
      var row = qb.closest('.li');
      var span = row && row.querySelector('.qty span');
      if (!span) return;
      var n = parseInt(span.textContent, 10) || 0;
      n = qb.dataset.qty === 'up' ? n + 1 : Math.max(0, n - 1);
      var inDrawer = !!qb.closest('#cart-drawer');
      var onCartPage = window.location.pathname.indexOf('/cart') === 0;
      qb.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qb.dataset.key, quantity: n })
      }).then(function () {
        if (inDrawer && !onCartPage) {
          return renderDrawer().then(refreshCart);
        }
        window.location.reload();
      }).catch(function () { qb.disabled = false; });
      return;
    }

    var opener = t.closest('[data-modal-open]');
    if (opener) {
      var m = document.getElementById(opener.dataset.modalOpen);
      if (!m) return;
      e.preventDefault();
      m.classList.add('is-open');
      m.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      m._rel = trap(m, function () { closeModal(m); });
      var mx = m.querySelector('.modal__x'); if (mx) mx.focus();
      return;
    }

    var closer = t.closest('[data-modal-close]');
    if (closer) {
      var mm = closer.closest('.modal');
      if (mm) { e.preventDefault(); closeModal(mm); }
    }
  });

  /* ---------------- add to cart ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { throw new Error(res.description || res.message); }
        return renderDrawer();
      })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        openCart();
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        alert(err.message || 'Could not add to cart.');
      });
  });

  /* ---------------- variant picking ---------------- */
  var picker = $('[data-variants]');
  if (picker) {
    var sync = function () {
      var chosen = [];
      $$('.opt').forEach(function (group) {
        var on = group.querySelector('input:checked');
        if (on) chosen.push(on.value);
      });
      var want = chosen.join(' / ');
      var match = $$('option', picker).filter(function (o) { return o.dataset.opts === want; })[0];
      var addBtn = $('[data-add]');
      if (match) {
        picker.value = match.value;
        var priceEl = $('[data-price]');
        if (priceEl && match.dataset.price) priceEl.textContent = match.dataset.price;
        if (addBtn) {
          addBtn.disabled = match.disabled;
          addBtn.textContent = match.disabled ? 'Sold out' : 'Add to cart';
        }
        var url = new URL(window.location);
        url.searchParams.set('variant', match.value);
        window.history.replaceState({}, '', url);
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    };
    $$('.opt__vals input[type="radio"]').forEach(function (i) { i.addEventListener('change', sync); });
    sync();
  }

  /* ---------------- countdown ---------------- */
  $$('.cd').forEach(function (sec) {
    var end = Date.parse(sec.dataset.deadline);
    var box = $('[data-countdown]', sec), done = $('[data-cd-done]', sec);
    if (!box || isNaN(end)) { if (box) box.hidden = true; return; }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var ms = end - Date.now();
      if (ms <= 0) { box.hidden = true; if (done) done.hidden = false; clearInterval(t); return; }
      var s = Math.floor(ms / 1000);
      $('[data-d]', sec).textContent = pad(Math.floor(s / 86400));
      $('[data-h]', sec).textContent = pad(Math.floor(s % 86400 / 3600));
      $('[data-m]', sec).textContent = pad(Math.floor(s % 3600 / 60));
      $('[data-s]', sec).textContent = pad(s % 60);
    };
    tick(); var t = setInterval(tick, 1000);
  });

  /* ---------------- lightbox ---------------- */
  (function () {
    var lb = $('#lightbox');
    if (!lb) return;
    var stage = $('[data-lb-stage]', lb), img = $('[data-lb-img]', lb);
    var countEl = $('[data-lb-count]', lb), levelEl = $('[data-lb-level]', lb);
    var prevBtn = $('.lb__prev', lb), nextBtn = $('.lb__next', lb);
    var items = [], idx = 0, scale = 1, tx = 0, ty = 0, release = null;

    function apply() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      levelEl.textContent = Math.round(scale * 100) + '%';
      stage.classList.toggle('is-zoomed', scale > 1);
    }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }
    function show(i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      img.src = it.full; img.alt = it.alt || '';
      countEl.textContent = items.length > 1 ? (idx + 1) + ' / ' + items.length : '';
      prevBtn.hidden = nextBtn.hidden = items.length < 2;
      reset();
    }
    function open(list, i) {
      items = list; lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      show(i);
      release = trap(lb, close);
      $('.lb__x', lb).focus();
    }
    function close() {
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (release) { release(); release = null; }
    }
    function zoom(delta, ox, oy) {
      var old = scale;
      scale = Math.min(5, Math.max(1, +(scale + delta).toFixed(2)));
      if (scale === 1) { tx = 0; ty = 0; }
      else if (ox !== undefined) {
        var r = stage.getBoundingClientRect();
        var dx = ox - r.left - r.width / 2, dy = oy - r.top - r.height / 2;
        var f = scale / old;
        tx = (tx - dx) * f + dx; ty = (ty - dy) * f + dy;
      }
      apply();
    }
    function zoomCentre(delta) { tx = 0; ty = 0; zoom(delta); }

    $$('[data-lb-close]', lb).forEach(function (b) { b.addEventListener('click', close); });
    $$('[data-lb-nav]', lb).forEach(function (b) {
      b.addEventListener('click', function () { show(idx + parseInt(b.dataset.lbNav, 10)); });
    });
    $$('[data-lb-zoom]', lb).forEach(function (b) {
      b.addEventListener('click', function () { zoomCentre(b.dataset.lbZoom === 'in' ? 0.5 : -0.5); });
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === '+' || e.key === '=') zoomCentre(0.5);
      if (e.key === '-') zoomCentre(-0.5);
    });
    stage.addEventListener('wheel', function (e) { e.preventDefault(); zoom(e.deltaY > 0 ? -0.25 : 0.25, e.clientX, e.clientY); }, { passive: false });
    stage.addEventListener('dblclick', function () { scale > 1 ? reset() : zoomCentre(1.5); });

    var dragging = false, sx = 0, sy = 0;
    stage.addEventListener('pointerdown', function (e) {
      if (scale <= 1) return;
      dragging = true; sx = e.clientX - tx; sy = e.clientY - ty;
      stage.classList.add('is-panning'); stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return; tx = e.clientX - sx; ty = e.clientY - sy; apply();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      stage.addEventListener(ev, function () { dragging = false; stage.classList.remove('is-panning'); });
    });

    var pts = {}, startDist = 0, startScale = 1;
    stage.addEventListener('pointerdown', function (e) { pts[e.pointerId] = e; });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = e;
      var k = Object.keys(pts);
      if (k.length === 2) {
        var a = pts[k[0]], b = pts[k[1]];
        var d2 = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        if (!startDist) { startDist = d2; startScale = scale; return; }
        scale = Math.min(5, Math.max(1, startScale * (d2 / startDist)));
        if (scale === 1) { tx = 0; ty = 0; }
        apply();
      }
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      stage.addEventListener(ev, function (e) { delete pts[e.pointerId]; startDist = 0; });
    });

    var tsx = 0, tsy = 0;
    stage.addEventListener('touchstart', function (e) { tsx = e.touches[0].clientX; tsy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (scale > 1 || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - tsx, dy = e.changedTouches[0].clientY - tsy;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });

    $$('[data-zoom-group]').forEach(function (group) {
      var pics = $$('[data-zoom]', group);
      var list = pics.map(function (p) { return { full: p.dataset.zoom, alt: p.alt }; });
      pics.forEach(function (p, i) {
        p.classList.add('zoomable');
        p.addEventListener('click', function () { open(list, i); });
        p.setAttribute('tabindex', '0');
        p.setAttribute('role', 'button');
        p.setAttribute('aria-label', 'Enlarge image ' + (i + 1));
        p.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(list, i); }
        });
      });
    });
  })();

  /* ---------------- sticky mobile buy bar ---------------- */
  (function () {
    var bar = $('[data-buybar]'), anchor = $('[data-add]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' }).observe(anchor);
    var btn = $('button', bar);
    if (btn) btn.addEventListener('click', function () {
      var form = anchor.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  })();

})();